module.exports = __webpack_public_path__ + "static/alieu-996f38f73e9c76edef975fcaadc9ed44.png";